// extracted by mini-css-extract-plugin
module.exports = {"background":"Sidebar_background__1Mnus","wrapper":"Sidebar_wrapper__2HF19","rendered":"Sidebar_rendered__2TfGO","close":"Sidebar_close__2PSMI"};